module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jaIc5"))).then(() => parcelRequire('hEqeo'));